import { jsx as _jsx } from "react/jsx-runtime";
import { tableContainerClasses as muiTableContainerClasses } from '@mui/material';
import { forwardRef } from 'react';
import { StickyTableContainer } from './TableContainer.styled';
const TableContainer = forwardRef((props, ref) => {
    return _jsx(StickyTableContainer, { ...props, ref: ref });
});
export { TableContainer };
export const tableContainerClasses = muiTableContainerClasses;
